<template>
  <el-card>
     <!-- 面包屑导航 -->
    <MyBread firstnav="专题分类管理" />
    <div>
      <!-- 专题分类管理 -->
      <el-row type="flex" justify="end">
        <el-button type="primary" @click="dialogFormVisible = true">添加分类</el-button>
        <el-dialog class="addDialog" title="添加分类" :visible.sync="dialogFormVisible">
          <el-form :model="typelist" >
            <el-form-item label="分类名称：" :label-width="formLabelWidth">
              <el-input  auto-complete="off" v-model="typelist.title"></el-input>
            </el-form-item>
            <el-form-item label="排序id：" :label-width="formLabelWidth">
              <el-input   auto-complete="off" v-model="typelist.sort"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="addType()">确 定</el-button>
          </div>
        </el-dialog>
      </el-row>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="title" label="分类" ></el-table-column>
        <el-table-column prop="sort" label="排序" ></el-table-column>
        <el-table-column fixed="right" label="操作" width="200" >
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="editType(scope.row)">编辑</el-button>
            <el-button type="text" size="medium" @click="deleteType(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="height: 50px"></div>
  </el-card>
</template>


<script>
import MyBread from '@/layout/bread.vue';
export default {
  components:{
    MyBread,
  },
  data() {
    return {
      name: "",
      tableData: [],
      typelist: {
        id: "",
        title: "",
        sort: ""
      },
      dialogFormVisible: false,
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      formLabelWidth: "120px"
    };
  },
  methods: {
    gettypelist: async function() {
      var res = await this.$http.get(`/v1/videoTopics/topicsTypeList`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.tableData = data;
      }
    },
    deleteType: function(row) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.post(`/v1/videoTopics/delTopicsType?id=${id}`);
          var { code, message, data } = res.data;
          if (code == 0) {
            this.$message.success("删除成功");
            this.gettypelist();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    addType: async function() {
      var res = await this.$http.post(
        `/v1/videoTopics/saveOrUpdateTopicsType`,
        this.typelist
      );
      var { data, code, message } = res.data;
      if (code == 0) {
        this.dialogFormVisible = false;
        this.$message.success("添加/编辑成功");
        this.gettypelist();
        this.typelist.title = ''
        this.typelist.sort = ''
      }else if(code == 40100){
        this.$message.error(message);
        this.$router.push('/login');
      } else {
        this.$message.error(message);
      }
    },
    editType: function(row) {
      this.typelist.id = row.id;
      this.typelist.sort = row.sort;
      this.typelist.title = row.title;
      this.dialogFormVisible = true;
    }
  },
  mounted() {
    this.gettypelist();
  }
};
</script>
<style scoped lang="scss">
.ipt-width{
  width: 300px;
}
.addDialog .el-form{
  padding: 0 120px;
}
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/topicType-mg/topicType.vue